import React from "react"
import Paginate from "react-paginate"

import {ChevronLeftIcon, ChevronRightIcon} from "@heroicons/react/24/outline"

type PageChangeProps = {
    selected: number
}

type PaginationProps = {
    page?: number,
    pageCount: number,
    onPageChange: (props: PageChangeProps) => void
}

export function Pagination({page, pageCount, onPageChange}: PaginationProps) {

    return <Paginate
        forcePage={page}
        onPageChange={onPageChange}
        pageCount={pageCount}
        pageRangeDisplayed={3}
        marginPagesDisplayed={3}
        containerClassName={"relative z-0 inline-flex shadow-sm"}
        activeLinkClassName={"bg-gray-200"}
        breakClassName="-ml-px relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm leading-5 font-medium text-gray-700"
        pageLinkClassName="px-4 py-2 cursor-pointer -ml-px relative inline-flex items-center border border-gray-300 text-sm leading-5 font-medium text-gray-700 hover:text-gray-500"
        previousClassName="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400"
        previousLabel={<ChevronLeftIcon className="w-5 h-5"/>}
        nextClassName="-ml-px relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400"
        nextLabel={<ChevronRightIcon className="w-5 h-5"/>}
    />
}